document.addEventListener('DOMContentLoaded', function () {
    const searchInput = document.querySelector('#search-modal .focus-me');
    const closeBtn = document.querySelector('.search-close-btn');
    function toggleCloseIcon() {
        if (searchInput.value.trim() !== '') {
            closeBtn.classList.add('active');
        } else {
            closeBtn.classList.remove('active');
        }
    }
    searchInput.addEventListener('input', toggleCloseIcon);
    toggleCloseIcon();
    closeBtn.addEventListener('click', function () {
        searchInput.value = '';
        closeBtn.classList.remove('active');
        searchInput.dispatchEvent(new Event('input', { bubbles: true }));
        searchInput.focus();
    });
});